<label
  class="inline-flex w-full items-center overflow-hidden transition duration-300 rounded-full select-none text-background"
  [class.cursor-pointer]="!disabled()"
  [class.cursor-not-allowed]="disabled()"
  [ngClass]="[
    ['h-12 min-w-20 text-variant-sm-medium', this.size() === 's'],
    ['h-16 min-w-28 text-variant-md-medium', this.size() === 'm'],
    ['h-20 min-w-36 text-variant-lg-medium', this.size() === 'l'],
    ['h-24 min-w-44 text-variant-xl-medium', this.size() === 'xl'],

    ['bg-primary border border-transparent hover:bg-primary-800', this.appearance() === 'primary' && !disabled() && checked()],
    ['bg-gray-400 border border-transparent hover:bg-gray-500', this.appearance() === 'primary' && !disabled() && !checked()],
    ['bg-primary-300', this.appearance() === 'primary' && disabled() && checked()],
    ['bg-gray-200', this.appearance() === 'primary' && disabled() && !checked()],

    ['bg-gray-300 border border-border hover:bg-gray-600', this.appearance() === 'secondary' && !disabled() && checked()],
    ['bg-gray-50 border border-border hover:bg-gray-400', this.appearance() === 'secondary' && !disabled() && !checked()],
    ['bg-background border border-border', this.appearance() === 'secondary' && disabled()],

    ['text-text', this.appearance() === 'secondary' && !disabled() && !checked()],
    ['text-disabled', this.appearance() === 'secondary' && disabled()  && !checked()],

    ['outline-primary-800 focus-within:border-primary-200 focus-within:outline-2', this.appearance() === 'primary' && !disabled()],
    ['outline-primary-300 focus-within:border-primary-600 focus-within:outline-2', this.appearance() === 'secondary' && !disabled()],
  ]"
  [style.--circle-size]="circleSize() + 'px'"
  [style.--gap-size]="gapSize() + 'px'"
  [style.--label-width]="'calc(100% - var(--circle-size) - 2 * var(--gap-size))'"
>
  <input
    type="checkbox"
    class="sr-only"
    [checked]="checked()"
    [disabled]="disabled()"
    (change)="onToggle($event)"
  />
  <div
    class="inline-flex items-center w-full gap-(--gap-size) transition duration-300"
    [style.transform]="checked() ? 'translateX(0px)' : 'translateX(calc(var(--label-width) * -1))'"
  >
    <span class="whitespace-nowrap overflow-hidden text-ellipsis shrink-0 pl-(--gap-size) w-(--label-width) text-center">
      {{ checkedLabel() }}
    </span>
    <span class="bg-background rounded-full shadow-lg h-(--circle-size) w-(--circle-size) shrink-0 border"
      [class.border-border]="appearance() === 'secondary'"></span>
    <span class="whitespace-nowrap overflow-hidden text-ellipsis shrink-0 w-(--label-width) text-center">
      {{ uncheckedLabel() }}
    </span>
  </div>
</label>
